import React from "react"

//-------Corporative
import BrandsHotels from "./views/corporative/BrandsHotels";
import RegionsCities from "./views/corporative/RegionsCities";
import CorporativeCatalogs from "./views/corporative/CorporativeCatalogs";
import CorporativeParsing from "./views/corporative/CorporativeParsing";
import Roles from "./views/corporative/Roles";
import Users from "./views/corporative/Users";
import AddUser from "./views/corporative/AddUser";

//-------Property
import Catalogs from "./views/property/Catalogs";
import CutOffDate from "./views/property/CutOffDate";
import Expressions from "./views/property/Expressions";
import ImportData from "./views/property/ImportData";
import ParsingDB from "./views/property/ParsingDB";
import Seasons from "./views/property/Seasons";
import Budget from "./views/property/Budget";
import Production from "./views/property/Production";


class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show_user_edited_notification : false,
            show_user_added_notification : false
        }
        this.setUserEditedNotification = this.setUserEditedNotification.bind(this);
        this.setUserAddedNotification = this.setUserAddedNotification.bind(this);
    }

    setUserEditedNotification(state){
        let self = this;
        self.setState({
            show_user_edited_notification : state
        });
    }

    setUserAddedNotification(state){
        let self = this;
        self.setState({
            show_user_added_notification : state
        });
    }

    render() {
        
        return (
            <div className="layout">
                { this.props.app.state.section_active == "brands-hotels" &&
                <div className={"brands-hotels "  + (this.props.app.state.section_active !== "brands-hotels" ? "section-hide" : "section-show")}>
                    <BrandsHotels
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        getHotels = {this.props.getHotels}
                        sys_tags = {this.props.sys_tags}
                        hotels = {this.props.hotels}
                        contracts_resume = {this.props.contracts_resume}
                    />
                </div>
                }
                { this.props.app.state.section_active == "regions-cities" &&
                <div className={"regions-cities "  + (this.props.app.state.section_active !== "regions-cities" ? "section-hide" : "section-show")}>
                    <RegionsCities
                        handleNotification = {this.props.handleNotification}
                        activeSection={this.props.activeSection}
                        item_active={this.props.item_active}
                    />
                </div>
                }
                { this.props.app.state.section_active == "corporative-catalogs" &&
                <div className={"corporative-catalogs "  + (this.props.app.state.section_active !== "corporative-catalogs" ? "section-hide" : "section-show")}>
                    <CorporativeCatalogs
                        catalogs={this.props.catalogs}
                        activeSection={this.props.activeSection}
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                     />
                </div>
                }
                { this.props.app.state.section_active == "corporative-parsing" &&
                <div className={"corporative-parsing "  + (this.props.app.state.section_active !== "corporative-parsing" ? "section-hide" : "section-show")}>
                    <CorporativeParsing
                        catalogs={this.props.catalogs}
                        activeSection={this.props.activeSection}
                        refreshCatalogSys={this.props.refreshCatalogSys}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                }
                {(this.props.app.state.section_active === "users") && 
                <div className={"roles "  + (this.props.app.state.section_active !== "users" ? "section-hide" : "section-show")}>
                    <Roles
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        activeSection={this.props.activeSection}
                        getHotels = {this.props.getHotels}
                        users = {this.props.users}
                        roles={this.props.roles}
                        business_id={this.props.business_id}
                        getUsers = {this.props.getUsers}
                        setEditingUser = {this.props.setEditingUser}
                        editing_user = {this.props.editing_user}
                        loading_users = {this.props.loading_users}
                        show_user_added_notification = {this.state.show_user_added_notification}
                        show_user_edited_notification = {this.state.show_user_edited_notification}
                        setUserAddedNotification = {this.setUserAddedNotification}
                        setUserEditedNotification = {this.setUserEditedNotification}
                    />
                </div>
                }
                
                {(this.props.app.state.section_active === "adduser") &&
                    <div className={"adduser "  + (this.props.app.state.section_active !== "adduser" ? "section-hide" : "section-show")}>
                        <AddUser
                            app={this.props.app}
                            activeSection={this.props.activeSection}
                            handleNotification = {this.props.handleNotification} 
                            item_active={this.props.item_active}
                            hotels={this.props.hotels}
                            roles={this.props.roles}
                            business_id={this.props.business_id}
                            getUsers = {this.props.getUsers}
                            setEditingUser = {this.props.setEditingUser}
                            editing_user = {this.props.editing_user}
                            setUserAddedNotification = {this.setUserAddedNotification}
                            setUserEditedNotification = {this.setUserEditedNotification}
                        />
                    </div>
                }
                { this.props.app.state.section_active == "catalogs" &&
                <div className={"catalogs "  + (this.props.app.state.section_active !== "catalogs" ? "section-hide" : "section-show")}>
                    <Catalogs 
                        app={this.props.app}
                        catalogs={this.props.catalogs}
                        handleNotification = {this.props.handleNotification}
                        renderSelectHotels = {this.props.renderSelectHotels}
                        hotel_selected = {this.props.hotel_selected}
                        item_active = {this.props.item_active}
                        activeSection={this.props.activeSection}
                    />
                </div>
                }
                { this.props.app.state.section_active == "cut-off-date" &&
                <div className={"cut-off-date "  + (this.props.app.state.section_active !== "cut-off-date" ? "section-hide" : "section-show")}>
                    <CutOffDate 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                }
                { this.props.app.state.section_active == "expressions" &&
                <div className={"expressions "  + (this.props.app.state.section_active !== "expressions" ? "section-hide" : "section-show")}>
                    <Expressions 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                }
                { this.props.app.state.section_active == "import-data" &&
                <div className={"import-data "  + (this.props.app.state.section_active !== "import-data" ? "section-hide" : "section-show")}>
                    <ImportData 
                        app={this.props.app}
                        renderSelectHotels={this.props.renderSelectHotels}
                        setActiveHotel = {this.props.setActiveHotel}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                }
                { this.props.app.state.section_active == "parsing-db" &&
                <div className={"parsing-db "  + (this.props.app.state.section_active !== "parsing-db" ? "section-hide" : "section-show")}>
                    <ParsingDB 
                        app={this.props.app}
                        catalogs={this.props.catalogs}
                        refreshCatalogSys={this.props.refreshCatalogSys}
                        updateCatalogCounter={this.props.updateCatalogCounter}
                        renderSelectHotels={this.props.renderSelectHotels}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        hotel_selected = {this.props.hotel_selected}
                        item_active = {this.props.item_active}
                    />
                </div>
                }
                { this.props.app.state.section_active == "seasons" &&
                <div className={"seasons "  + (this.props.app.state.section_active !== "seasons" ? "section-hide" : "section-show")}>
                    <Seasons 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        renderSelectHotels={this.props.renderSelectHotels}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        hotel_selected = {this.props.hotel_selected}   
                        setActiveHotel = {this.props.setActiveHotel} 
                    />
                </div>
                }
                { this.props.app.state.section_active == "budget" &&
                <div className={"budget "  + (this.props.app.state.section_active !== "budget" ? "section-hide" : "section-show")}>
                    <Budget 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        renderSelectHotels={this.props.renderSelectHotels}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        hotel_selected = {this.props.hotel_selected}   
                        setActiveHotel = {this.props.setActiveHotel} 
                    />
                </div>
                }
                { this.props.app.state.section_active == "production" &&
                <div className={"production "  + (this.props.app.state.section_active !== "production" ? "section-hide" : "section-show")}>
                    <Production 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        renderSelectHotels={this.props.renderSelectHotels}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        hotel_selected = {this.props.hotel_selected}   
                        setActiveHotel = {this.props.setActiveHotel} 
                    />
                </div>
                }
            </div>
        )
    }

}

export default Layout



// WEBPACK FOOTER //
// ./src/Setup/modules/setup/Layout.js